<template>
  <button
    :id="props.idPopover"
    ref="buttonRef"
    :disabled="!active"
    :class="[
      'default-button bulk-actions filter-button tw-px-4 tw-py-4 tw-flex tw-items-center',
      props.buttonClass,
      props.active ? 'hover__button' : 'disable-button',
      (props.showMoreActions && active) || props.isFilter
        ? ' !tw-bg-[#211F58] !tw-text-[#FFF]'
        : '',
      props.isMarginRight ? 'tw-mr-5' : '',
    ]"
    type="button"
    :style="!active ? 'cursor: not-allowed;' : 'cursor:pointer;'"
    @click="onClick"
    @mouseenter="isHover = true"
    @mouseleave="isHover = false"
  >
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7267 6.2225C13.0917 5.63603 13.3006 4.96587 13.3333 4.27583V2.77583C13.3333 1.9425 11.6667 0.0625 6.66667 0.0625C1.66667 0.0625 0 1.9425 0 2.77583V4.27583C0.046288 5.20851 0.413723 6.09648 1.04 6.78917L5.33333 11.0825V14.9425C5.33333 15.2077 5.43869 15.4621 5.62623 15.6496C5.81376 15.8371 6.06812 15.9425 6.33333 15.9425H7C7.26522 15.9425 7.51957 15.8371 7.70711 15.6496C7.89464 15.4621 8 15.2077 8 14.9425V13.2625C8.92352 13.6511 9.95338 13.7065 10.9133 13.4194C11.8732 13.1323 12.7035 12.5205 13.262 11.6886C13.8205 10.8568 14.0724 9.85671 13.9748 8.85955C13.8771 7.86239 13.4359 6.93018 12.7267 6.2225ZM6.66667 1.39583C10 1.39583 12 2.43583 12 3.0025C12 3.56917 10 4.60917 6.66667 4.60917C3.33333 4.60917 1.33333 3.56917 1.33333 3.0025C1.33333 2.43583 3.36 1.39583 6.66667 1.39583ZM9.66667 12.2758C9.10802 12.2751 8.56071 12.1181 8.08667 11.8225C8.06036 11.8081 8.03843 11.7869 8.02318 11.7611C8.00793 11.7353 7.99992 11.7058 8 11.6758V11.1492C8.00139 11.105 8.01786 11.0627 8.04667 11.0292L11.7133 7.3625C11.7303 7.34664 11.7502 7.33434 11.7719 7.32633C11.7937 7.31831 11.8168 7.31474 11.84 7.31583C11.8634 7.31499 11.8867 7.32004 11.9077 7.33052C11.9286 7.34101 11.9466 7.35659 11.96 7.37583C12.4118 7.90625 12.6621 8.57907 12.6667 9.27583C12.6649 10.0709 12.3483 10.833 11.786 11.3952C11.2238 11.9574 10.4618 12.2741 9.66667 12.2758Z"
        :fill="`${
          props.showMoreActions || props.isFilter || (isHover && active)
            ? '#fff'
            : '#b7b7b7'
        }`"
      />
    </svg>
    <span
      :class="`tw-pl-[9px] ${props.isFilter ? 'tw-text-[#fff]' : ''} ${
        !props.showMoreActions ? 'tw-text-[#b7b7b7]' : ''
      } `"
      >{{ getComponentUiText("app-table-filter-text-1") }}</span
    >
  </button>
  <div ref="dropdownRef">
    <CustomDropDown
      :id-popover="props.idPopover"
      :class="
        !props.showMoreActions
          ? 'tw-invisible'
          : 'tw-border-none filter-actions-popover'
      "
      placement="bottom-end"
      :offset="15"
      :show-acction-click="true"
      :show-more-actions="props.showMoreActions"
    >
      <template v-if="props.showMoreActions && props.active" #default>
        <slot />
      </template>
    </CustomDropDown>
  </div>
</template>

<script lang="ts" setup>
import { getComponentUiText } from "@/utils/utilities";
import CustomDropDown from "@/components/common/customDropDownManual.vue";
import { ref, onMounted, onBeforeUnmount } from "vue";

const props = defineProps({
  active: { type: Boolean, required: true, default: false },
  showMoreActions: { type: Boolean, required: false, default: false },
  idPopover: {
    type: String,
    required: false,
    default: `idPopover-bulk-action-${Math.random() * 1000}`,
  },
  buttonClass: { type: String, required: false, default: "" },
  isFilter: { type: Boolean, required: false, default: false },
  isMarginRight: { type: Boolean, required: false, default: false },
  selectedNumber: { type: Number, required: false, default: 0 },
});
const isHover = ref(false);
const dropdownRef = ref<HTMLElement | null>(null);
const buttonRef = ref<HTMLElement | null>(null);

const emit = defineEmits(["click", "click-away"]);

const onClick = () => {
  emit("click");
};

const handleClickAway = (event: MouseEvent) => {
  const dropdownEl = dropdownRef.value;
  const buttonEl = buttonRef.value;
  if (
    props.showMoreActions &&
    dropdownEl &&
    buttonEl &&
    !dropdownEl.contains(event.target as Node) &&
    !buttonEl.contains(event.target as Node)
  ) {
    console.log("Click away detected");
    emit("click-away");
  }
};

onMounted(() => {
  document.addEventListener("mousedown", handleClickAway);
});
onBeforeUnmount(() => {
  document.removeEventListener("mousedown", handleClickAway);
});
</script>

<style lang="scss" scoped>
.default-button {
  border: none;
  height: 44px;
  color: #211f58;
  background-color: #ffffff;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
}
.show {
  transform: rotate(180deg);
}
.default-button.bulk-actions svg {
  fill: #387dff;
}

.default-button.disable-button {
  color: #b7b7b7;
}

.default-button.disable-button svg {
  fill: #b7b7b7;
}

.org-modal-contain .bulk-actions,
.search-modal-contain .bulk-actions .category-header .bulk-actions {
  margin-right: 20px;
}

.category-header .bulk-actions {
  border: 1px solid var(--ui-rule, #eff0f1);
}
.hover__button:hover {
  background-color: #211f58;
  span {
    color: #fff !important;
  }
}
</style>
